if (!customElements.get('wls-product-recommendations')) {
  class WLSProductRecommendations extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        hidden: 'hidden',
        productRecommendations: 'js-wls-product-recommendations',
        swiper: 'js-wls-product-recommendations-swiper',
        swiperButtonPrev: 'js-wls-product-recommendations-swiper-button-prev',
        swiperButtonNext: 'js-wls-product-recommendations-swiper-button-next',
      };

      this.selectors = this.getSelectors();
    }

    getSelectors() {
      return {
        productId: this.getAttribute('product-id'),
        intent: this.getAttribute('intent'),
        limit: this.getAttribute('limit'),
        sectionId: this.getAttribute('data-section-id'),
        productRecommendations: this.querySelector(`.${this.classes.productRecommendations}`),
        swiper: this.querySelector(`.${this.classes.swiper}`),
      };
    }
    /**
     * Lifecycle method called when the element is added to the DOM.
     * It sets up event listeners for each tag to handle tag selection.
     *
     * @returns {void}
     */
    connectedCallback() {
      if (this.selectors.intent) {
        this.fetchRecommendations();
      } else {
        // this.initializeSwiper();
        this.classList.remove(this.classes.hidden);
      }
    }

    async fetchRecommendations() {
      try {
        const productId = `product_id=${this.selectors.productId}`;
        const intent = `intent=${this.selectors.intent}`;
        const limit = `limit=${this.selectors.limit}`;
        const sectionId = `section_id=${this.selectors.sectionId}`;
        const baseUrl = `${window.Shopify.routes.root}recommendations/products`;

        const response = await fetch(`${baseUrl}?${productId}&${intent}&${limit}&${sectionId}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        this.selectors.productRecommendations.innerHTML =
          doc.querySelector(`.${this.classes.productRecommendations}`)?.innerHTML || '';

        this.classList.remove(this.classes.hidden);

        // Initialize swiper after content is loaded
        // this.initializeSwiper();
      } catch (error) {
        console.error('Error fetching recommendations:', error);
      }
    }

    /**
     * Initialize Swiper.
     *
     * @returns {void}
     */
    initializeSwiper() {
      const swiperElement = this.querySelector(`.${this.classes.swiper}`);
      const swiperButtonPrev = this.querySelector(`.${this.classes.swiperButtonPrev}`);
      const swiperButtonNext = this.querySelector(`.${this.classes.swiperButtonNext}`);

      if (!swiperElement) return;
      this.swiper = new Swiper(swiperElement, {
        loop: true,
        spaceBetween: 48,
        slidesPerView: 1,
        navigation: {
          nextEl: swiperButtonNext,
          prevEl: swiperButtonPrev,
          enabled: swiperButtonNext && swiperButtonPrev,
        },
        breakpoints: {
          768: {
            spaceBetween: 24,
          },
        },
      });
    }
  }

  window.customElements.define('wls-product-recommendations', WLSProductRecommendations);
}
